import { render } from "./Home.vue?vue&type=template&id=ef372fe2"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=ef372fe2&lang=css"
script.render = render

export default script